import { Controller } from "@hotwired/stimulus"
import { browserSupportsWebAuthn, startRegistration } from "@simplewebauthn/browser"
import { postJSON, PasskeyRequestError, isAbort, isCancel } from "../src/passkey_api"

// プロフィールの「パスキー」欄から、名前を付けてこの端末のパスキーを登録する。
// 成功するとサーバーが返す URL(プロフィール)へ遷移し、フラッシュで結果を出す。
export default class extends Controller {
  static targets = ["form", "name", "submit", "error", "unsupported"]
  static values = {
    optionsUrl: String,
    createUrl: String,
    failedMessage: String,
    cancelledMessage: String,
    alreadyRegisteredMessage: String
  }

  connect() {
    const supported = browserSupportsWebAuthn()
    if (this.hasFormTarget) this.formTarget.hidden = !supported
    if (this.hasUnsupportedTarget) this.unsupportedTarget.hidden = supported
  }

  async register(event) {
    event.preventDefault()
    this.clearError()
    this.submitTarget.disabled = true

    try {
      const optionsJSON = await postJSON(this.optionsUrlValue)
      const credential = await startRegistration({ optionsJSON })
      const { redirect_url: redirectUrl } = await postJSON(this.createUrlValue, {
        name: this.nameTarget.value,
        credential
      })
      window.location.assign(redirectUrl)
    } catch (error) {
      this.handleError(error)
      this.submitTarget.disabled = false
    }
  }

  handleError(error) {
    if (isAbort(error)) return
    if (isCancel(error)) return this.showError(this.cancelledMessageValue)
    // excludeCredentials に当たった = この端末(パスワードマネージャー)には登録済み
    if (error?.name === "InvalidStateError") return this.showError(this.alreadyRegisteredMessageValue)
    if (error instanceof PasskeyRequestError && error.message) return this.showError(error.message)

    this.showError(this.failedMessageValue)
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.hidden = false
  }

  clearError() {
    this.errorTarget.textContent = ""
    this.errorTarget.hidden = true
  }
}
